import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

/** Paginação feita no servidor: página atual, total e os dois botões. Some com uma página só. */
export function PaginationBar({
  page,
  pageSize,
  total,
  onPageChange,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPageChange: (page: number) => void;
}) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  if (pages <= 1) return null;
  return (
    <nav aria-label="Paginação" className="flex items-center justify-end gap-2 text-sm">
      <span className="tabular mr-auto text-muted-foreground">{total} no total</span>
      <Button
        variant="outline"
        size="sm"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
      >
        <ChevronLeft aria-hidden /> Anterior
      </Button>
      <span className="tabular" aria-current="page">
        {page} de {pages}
      </span>
      <Button
        variant="outline"
        size="sm"
        disabled={page >= pages}
        onClick={() => onPageChange(page + 1)}
      >
        Próxima <ChevronRight aria-hidden />
      </Button>
    </nav>
  );
}
